import { axios } from "../utils/axios";
const baseUrl = process.env.REACT_APP_API_HOST;

export const reAllocateChart = async (data, worklistId) => {
  let jsonData;
  let postBody = {
    from: Number(data.from),
    to: Number(data.to),
    userId: Number(data.assign_to),
    worklistId: worklistId,
  };

  try {
    let res = await axios.post(
      `${baseUrl}/worklists/allocate-volume`,
      postBody,
    );
    if (res?.success === true) {
      window.toastr.success(res.message);
    }
    jsonData = res;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;

      window.toastr.error(jsonData.message);
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const allocateChart = async (data, worklistId) => {
  let jsonData;
  let postData = {
    ...data,
    worklistId: Number(worklistId),
  };
  try {
    let res = await axios.post(`${baseUrl}/worklists/assign-charts`, postData);
    if (res?.success === true) {
      window.toastr.success(res.message);
    }
    jsonData = res;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;

      window.toastr.error(jsonData.message);
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const fetchWorklistRecords = async (
  data,
  currentPage,
  limit,
  sortColumn,
  sortDirection,
) => {
  let jsonData;
  try {
    let res = await axios.post(
      `${baseUrl}/worklists/worklist-filter?page=${currentPage}&size=${limit}&column=${sortColumn}&direction=${sortDirection}`,
      data,
    );
    jsonData = res;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const fetchWorklistRecord = async (worklist_id) => {
  let jsonData;
  try {
    let res = await axios.get(`${baseUrl}/worklists/${worklist_id}`);
    jsonData = res.data;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const fetchAvailableAllocation = async (worklist_id) => {
  let jsonData;
  try {
    let res = await axios.get(
      `${baseUrl}/worklists/${worklist_id}/available-allocation-volume`,
    );
    jsonData = res.data;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const fetchWorklistProgress = async (worklist_id) => {
  let jsonData;
  try {
    let res = await axios.get(
      `${baseUrl}/worklists/${worklist_id}/worklist-chart-progress`,
    );
    jsonData = res.data;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const fetchAvailableReAllocation = async (
  rangeFrom,
  rangeTo,
  worklistId,
) => {
  let jsonData;
  try {
    let res = await axios.get(
      `${baseUrl}/worklists/${worklistId}/available-reallocation-volume?from=${rangeFrom}&to=${rangeTo}`,
    );
    jsonData = res.data;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const checkCoder = async (id, worklistId) => {
  let jsonData;
  try {
    let res;
    res = await axios.get(
      `${baseUrl}/worklists/check-coder/${id}/${worklistId}`,
    );
    jsonData = res.data;
  } catch (e) {}
  return jsonData;
};

export const deleteWorklist = async (worklistId) => {
  let res;
  try {
    res = await axios.delete(`${baseUrl}/worklists/${worklistId}/`);
  } catch (e) {}
  return res?.data;
};

export const saveNewChartInWorkList = async (worklist_no) => {
  let jsonData;
  try {
    let res = await axios.post(`${baseUrl}/worklists/${worklist_no[0]?.id}/charts`, worklist_no);
    jsonData = res;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};